<template>
    <ItemCard :title="draft.checklist_title">
        <template v-if="draft.todo">
            <template v-if="overdue">
                <div class="badge state-bad">
                    {{ $t("Overdue") }}
                </div>
                <p class="badge-explanation">{{ $t('since {date}', {date: $du(draft.due_at, 'shortDateTime')}) }}</p>
            </template>

            <template v-else>
                <div  class="badge state-medium">
                    {{ $t("Due") }}
                </div>
                <p class="badge-explanation">{{ $t('at {date}', {date: $du(draft.due_at, 'shortDateTime')}) }}</p>
            </template>
        </template>
        <template v-else-if="draft.checklist">
            <div  class="badge state-good">
                {{ $t("Template") }}
            </div>
            <p class="badge-explanation">{{ $t('started at {date}', {date: $du(draft.started_at, 'shortDateTime')}) }}</p>
        </template>
    </ItemCard>

</template>

<script>
import ItemCard from '@mobile/components/ItemCard.vue';
import { now } from '@/util/UnixTimestamps';

export default {

    components: { ItemCard },

    props: {
        draft: {
            type: Object,
            required: true,
        },
    },

    computed: {

        overdue() {
            return this.draft.due_at < now();
        },
    },

    methods: {

    },

};
</script>
